import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-premiere-background',
  templateUrl: './mobile-premiere-background.component.html',
  styleUrls: ['./mobile-premiere-background.component.css']
})
export class MobilePremiereBackgroundComponent implements OnInit {
@Input('mobilePremiereDetails')mobilePremiereDetails:any;
  constructor() { }

  ngOnInit(): void {
  }
  back(){
    history.back()
  }
}
